<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill_condition`]" width="1em" height="1em" v-bind="$attrs"><path d="M3.43424 2.14062C2.72297 2.14062 2.14206 2.72149 2.14206 3.43225V6.44907C2.14206 7.1587 2.55343 8.15199 3.05699 8.65456L8.20048 13.798C8.70247 14.3011 9.52398 14.3011 10.0271 13.798L13.8001 10.0256C14.3026 9.52254 14.3026 8.70041 13.8001 8.1979L8.65608 3.05444C8.15351 2.55137 7.16134 2.14062 6.45059 2.14062H3.43424ZM5.15057 6.4385C4.43874 6.4385 3.86121 5.86096 3.86121 5.14914C3.86121 4.43725 4.43874 3.85978 5.15057 3.85978C5.86245 3.85978 6.43994 4.4373 6.43994 5.14914C6.43994 5.86094 5.86245 6.4385 5.15057 6.4385Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillCondition',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
